import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { auth } from './firebase/config.js'
//vSelect
import vSelect from 'vue-select'
Vue.component('v-select', vSelect)
import 'vue-select/dist/vue-select.css';

//plugins
//import VModal from 'vue-js-modal/dist/index.nocss.js'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
//import CoolSelectPlugin from 'vue-cool-select'

//theme
// Import Bootstrap an BootstrapVue CSS files (order is important)
//import 'bootstrap/dist/css/bootstrap.css'
//import 'bootstrap-vue/dist/bootstrap-vue.css'

import '../scss/custom.scss'  // theming bootstrap

//import 'bootstrap/dist/css/bootstrap.min.css'
import 'vue-js-modal/dist/styles.css'

Vue.config.productionTip = false

//Vue.use(VModal)
// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)

auth.onAuthStateChanged(user => {
  store.dispatch("fetchUser", user);
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')